/* eslint-disable */

$(function() {

    $('#occasion_financiering_bereken').on('click', function () {
        const button = $(this);
        button.text('Laden...');
        button.attr('disabled', true);
        const form = $('#occasion_financiering_bereken').parents('form');
        const looptijd = form.find('select[name="looptijd"]').val().replace(' maanden', '');
        const slottermijn = form.find('input[name="slottermijn"]').val();
        const aanbetaling = form.find('input[name="aanbetaling"]').val();
        const ajaxurl = form.find('input[name="ajaxurl"]').val();
        const price = form.find('input[name="price"]').val();

        $.ajax({
            url: ajaxurl,
            method: 'POST',
            data: {
                action: 'occasion_finance',
                loanAmount: price,
                termijn: looptijd,
                balloon: slottermijn,
                downpayment: aanbetaling,
            },
            success: function (response) {
                response = JSON.parse(response);
                form.find('#occasion_financiering_berekening').slideDown();
                form.find('input[name="aanbetaling"]').val(response.downpayment);
                form.find('input[name="slottermijn"]').val(response.balloon);
                form.find('input[name="termijnbedrag"]').val(response.instalment);
                form.find('input[name="financieringsbedrag"]').val(response.loanAmount);
                form.find('input[name="rente"]').val(response.apr);
                form.find('input[name="totaalbedrag"]').val(response.totalLoanAmount);
                button.text('Berekenen');
                button.attr('disabled', false);
            },
            error: function (error) {
                alert('Er is iets fout gegaan, neem contact op met Cappendijk of probeer het opnieuw.');
                $(this).text('Opnieuw proberen...');
                console.error(error);
                console.log(error.responseText);
            }
        });
    });

    $('#popup--kopen-stap1 [data-kopen="kopen-stap2"]').on('click', function () {
        const levering = $('#popup--kopen-stap1 input[name="radioLevering"]:checked');
        if (!levering.length) {
            return alert('Selecteer een optie.');
        }

        window.togglePopup('kopen-stap2');
    });

    $('#popup--kopen-stap2 [data-kopen="kopen-stap3"]').on('click', function () {
        const afleverpakket = $('#popup--kopen-stap2 input[name="radioAfleverpakket"]:checked');
        if (!afleverpakket.length) {
            return alert('Selecteer een afleverpakket.');
        }

        window.togglePopup('kopen-stap3');
    });

    $('#popup--kopen-stap3 [data-kopen="kopen-stap4"]').on('click', function () {
        const naam = $('#popup--kopen-stap3 input[name="naam"]').val();
        if (naam === '') {
            return alert('Vul jouw naam in');
        }
        const achternaam = $('#popup--kopen-stap3 input[name="achternaam"]').val();
        if (achternaam === '') {
            return alert('Vul jouw achternaam in.');
        }
        const email = $('#popup--kopen-stap3 input[name="email"]').val();
        if (email === '') {
            return alert('Vul jouw e-mailadres in.');
        }
        const telefoonnummer = $('#popup--kopen-stap3 input[name="telefoonnummer"]').val();
        if (telefoonnummer === '') {
            return alert('Vul jouw telefoonnummer in.');
        }
        const straatnaam = $('#popup--kopen-stap3 input[name="straatnaam"]').val();
        if (straatnaam === '') {
            return alert('Vul jouw straatnaam in.');
        }
        const postcode = $('#popup--kopen-stap3 input[name="postcode"]').val();
        if (postcode === '') {
            return alert('Vul jouw postcode in.');
        }
        const huisnummer = $('#popup--kopen-stap3 input[name="huisnummer"]').val();
        if (huisnummer === '') {
            return alert('Vul jouw huisnummer in.');
        }
        const woonplaats = $('#popup--kopen-stap3 input[name="woonplaats"]').val();
        if (woonplaats === '') {
            return alert('Vul jouw woonplaats in.');
        }
        const geboortedatum = $('#popup--kopen-stap3 input[name="geboortedatum"]').val();
        if (geboortedatum === '') {
            return alert('Vul jouw geboortedatum in.');
        }
        const rijbewijsnummer = $('#popup--kopen-stap3 input[name="rijbewijsnummer"]').val();
        if (rijbewijsnummer === '') {
            return alert('Vul jouw rijbewijsnummer in.');
        }

        const afleveradres = $('#popup--kopen-stap3 #customCheckAfleveradres').prop('checked');
        if (afleveradres) {
            const aflever_straatnaam = $('#popup--kopen-stap3 input[name="aflever_straatnaam"]').val();
            if (aflever_straatnaam === '') {
                return alert('Vul jouw aflever straatnaam in.');
            }

            const aflever_postcode = $('#popup--kopen-stap3 input[name="aflever_postcode"]').val();
            if (aflever_postcode === '') {
                return alert('Vul een aflever postcode in.');
            }

            const aflever_huisnummer = $('#popup--kopen-stap3 input[name="aflever_huisnummer"]').val();
            if (aflever_huisnummer === '') {
                return alert('Vul een aflever huisnummer in.');
            }

            const aflever_plaats = $('#popup--kopen-stap3 input[name="aflever_plaats"]').val();
            if (aflever_plaats === '') {
                return alert('Vul een aflever huisnummer in.');
            }
        }

        window.togglePopup('kopen-stap4');
    });

    $('#popup--kopen-stap3 #customCheckAfleveradres').on('change', function () {
        if ($(this).prop('checked')) {
            $('#popup--kopen-stap3 #divAfleverAdres').css('display', 'block');
        } else {
            $('#popup--kopen-stap3 #divAfleverAdres').css('display', 'none');
        }
    });

    $('#formBetaling').on('submit', function (event) {
        event.preventDefault();

        const levering = $('#popup--kopen-stap1 input[name="radioLevering"]:checked');
        if (!levering.length) {
            return alert('Selecteer een optie bij stap 1.');
        }

        const afleverpakket = $('#popup--kopen-stap2 input[name="radioAfleverpakket"]:checked');
        if (!afleverpakket.length) {
            return alert('Selecteer een afleverpakket bij stap 2.');
        }

        const naam = $('#popup--kopen-stap3 input[name="naam"]').val();
        if (naam === '') {
            return alert('Vul jouw naam in bij stap 3.');
        }
        const achternaam = $('#popup--kopen-stap3 input[name="achternaam"]').val();
        if (achternaam === '') {
            return alert('Vul jouw achternaam in bij stap 3.');
        }
        const email = $('#popup--kopen-stap3 input[name="email"]').val();
        if (email === '') {
            return alert('Vul jouw e-mailadres in bij stap 3.');
        }
        const telefoonnummer = $('#popup--kopen-stap3 input[name="telefoonnummer"]').val();
        if (telefoonnummer === '') {
            return alert('Vul jouw telefoonnummer in bij stap 3.');
        }
        const straatnaam = $('#popup--kopen-stap3 input[name="straatnaam"]').val();
        if (straatnaam === '') {
            return alert('Vul jouw straatnaam in bij stap 3.');
        }
        const postcode = $('#popup--kopen-stap3 input[name="postcode"]').val();
        if (postcode === '') {
            return alert('Vul jouw postcode in bij stap 3.');
        }
        const huisnummer = $('#popup--kopen-stap3 input[name="huisnummer"]').val();
        if (huisnummer === '') {
            return alert('Vul jouw huisnummer in bij stap 3.');
        }
        const woonplaats = $('#popup--kopen-stap3 input[name="woonplaats"]').val();
        if (woonplaats === '') {
            return alert('Vul jouw woonplaats in bij stap 3.');
        }
        const geboortedatum = $('#popup--kopen-stap3 input[name="geboortedatum"]').val();
        if (geboortedatum === '') {
            return alert('Vul jouw geboortedatum in bij stap 3.');
        }
        const rijbewijsnummer = $('#popup--kopen-stap3 input[name="rijbewijsnummer"]').val();
        if (rijbewijsnummer === '') {
            return alert('Vul jouw rijbewijsnummer in bij stap 3.');
        }

        const afleveradres = $('#popup--kopen-stap3 #customCheckAfleveradres').prop('checked');

        let aflever_straatnaam = straatnaam;
        let aflever_postcode = postcode;
        let aflever_huisnummer = huisnummer;
        let aflever_plaats = woonplaats;

        if (afleveradres) {
            aflever_straatnaam = $('#popup--kopen-stap3 input[name="aflever_straatnaam"]').val();
            if (aflever_straatnaam === '') {
                return alert('Vul jouw aflever straatnaam in bij stap 3.');
            }

            aflever_postcode = $('#popup--kopen-stap3 input[name="aflever_postcode"]').val();
            if (aflever_postcode === '') {
                return alert('Vul een aflever postcode in bij stap 3.');
            }

            aflever_huisnummer = $('#popup--kopen-stap3 input[name="aflever_huisnummer"]').val();
            if (aflever_huisnummer === '') {
                return alert('Vul een aflever huisnummer in bij stap 3.');
            }

            aflever_plaats = $('#popup--kopen-stap3 input[name="aflever_plaats"]').val();
            if (aflever_plaats === '') {
                return alert('Vul een aflever plaats in bij stap 3.');
            }
        }

        $.ajax({
            url: event.target.action,
            method: 'POST',
            data: {
                action: 'occasion_kopen',
                voertuig: $('#popup--kopen-stap4 input[name="voertuig"]').val(),
                levering: levering[0].value,
                afleverpakket: afleverpakket[0].value,
                persoonsgegevens: {
                    naam: naam,
                    achternaam: achternaam,
                    email: email,
                    telefoonnummer: telefoonnummer,
                    straatnaam: straatnaam,
                    postcode: postcode,
                    huisnummer: huisnummer,
                    woonplaats: woonplaats,
                    geboortedatum: geboortedatum,
                    rijbewijsnummer: rijbewijsnummer,
                    afleveradres: afleveradres,
                    aflever_straatnaam: aflever_straatnaam,
                    aflever_postcode: aflever_postcode,
                    aflever_huisnummer: aflever_huisnummer,
                    aflever_plaats: aflever_plaats,
                },
            },
            success: function (response) {
                response = JSON.parse(response);
                if (response.popup) {
                    togglePopup(response.popup);
                } else if (response.redirect) {
                    window.location = response.redirect;
                } else if (response.error) {
                    alert(response.error);
                } else {
                    alert('Er is iets fout gegaan, neem contact op met Cappendijk of probeer het opnieuw.');
                }
            },
            error: function (error) {
                alert('Er is iets fout gegaan, neem contact op met Cappendijk of probeer het opnieuw.');
                console.error(error);
                console.log(error.responseText);
            }
        });
        return false;
    });
});
